export default "__VITE_ASSET__de3ad3e5__"